iScreenWizard.controller('C2PResultatenController', function ($scope, $state, $mdDialog, $filter, Ajax, Dictionary, ErrorHandler, userService, c2pService, Matchingrapporttype) {

    $scope.userService = userService;
    $scope.c2p = c2pService.model;

    $scope.competentieprofielen = [];
    $scope.matchingrapporttypes = [];
    $scope.rapport_type = 1;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        Matchingrapporttype.all().then(function(matchingrapporttypes) {
           $scope.matchingrapporttypes = matchingrapporttypes;
        });

        params = {
            _method: 'get_resultaten_competentieprofielen',
            matching_session_id: c2pService.model.matching_session_id
        };
        angular.forEach(c2pService.model.competentieprofielen, function(competentieprofiel) {
            angular.forEach(competentieprofiel.competentietypes, function(competentietype) {
                angular.forEach(competentietype.competenties, function(competentie) {
                    params["ideaalscores["+competentieprofiel.id+"]["+competentie.id+"][min]"] = competentie.min_ideaalscore_aangepast;
                    params["ideaalscores["+competentieprofiel.id+"]["+competentie.id+"][max]"] = competentie.max_ideaalscore_aangepast;
                });
            });
        });
        Ajax.post('matching', params).then(function(response) {
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                $scope.competentieprofielen = response.data.competentieprofielen;
            }
        });
    };
    $scope.refresh = refresh;

    $scope.downloadRapport = function(ev) {
        $mdDialog.show({
            controller: DownloadRapportDialogController,
            locals: {
                rapport_type: $scope.rapport_type
            },
            templateUrl: '/matching/download-rapport',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    function DownloadRapportDialogController($scope, $mdDialog, c2pService, rapport_type) {
        $scope.stillLoading = true;
        $scope.downLoadUrl = '';

        var params = {
            _method: 'genereer_rapport_competentieprofielen',
            matching_session_id: c2pService.model.matching_session_id,
            rapport_type: rapport_type,
        };

        Ajax.post('matching', params).then(function (response) {
            $scope.stillLoading = false;
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                $scope.downLoadUrl = baseUrl + response.data.file_url + '?jwt=' + userService.getToken();
            }
        });
    };


});